exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1GxQH{clear:both;width:100%}._3gk0S{text-align:center;margin:10px 0 5px;color:#b8b8b8;font-size:16px}", ""]);

// exports
exports.locals = {
	"loadMore": "_1GxQH",
	"loadText": "_3gk0S"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/components/common/LoadMore/index.css
// module id = 957
// module chunks = 1 2 3 5 8